import { render, staticRenderFns } from "./ModgroupModifiers.vue?vue&type=template&id=01ac7c05"
import script from "./ModgroupModifiers.vue?vue&type=script&lang=ts"
export * from "./ModgroupModifiers.vue?vue&type=script&lang=ts"
import style0 from "./ModgroupModifiers.vue?vue&type=style&index=0&id=01ac7c05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports